<h1>{{'Oops, trop de monde d\'un coup !' | transloco}}</h1>
<p class="margin-bottom-50">{{'Pouvez-vous reessayer plus tard ?' | transloco}}</p>
<a [href]="hostingUrl"
   mat-raised-button
   class="mat-elevation-z"
   color="primary">
    {{ 'decouvrir en attendant infomaniak' | transloco }}
</a>
